import { AlertTriangle, Banknote, CheckCircle2, CircleGauge, WalletCards } from "lucide-react";

const suppliers = [
  { name: "روشن تجارتی سپلائیز", amount: "86,460", width: "w-[86%]" }, // i18n-allow: tri-locale data / Urdu-only demo
  { name: "نیشنل فوڈ انڈسٹریز", amount: "28,690", width: "w-[48%]" }, // i18n-allow: tri-locale data / Urdu-only demo
  { name: "جدہ پیکجنگ سلوشنز", amount: "18,050", width: "w-[31%]" }, // i18n-allow: tri-locale data / Urdu-only demo
];

export function UrduDashboardPreview() {
  return (
    <div
      dir="rtl"
      lang="ur"
      aria-label="سیڈا اکاؤنٹنگ ڈیش بورڈ کا اردو نمونہ، تمام معلومات فرضی ہیں" // i18n-allow: tri-locale data / Urdu-only demo
      className="overflow-hidden rounded-lg border border-border bg-card shadow-xl shadow-primary/10"
    >
      <div className="flex items-center justify-between gap-3 border-b border-border bg-card px-4 py-3 sm:px-6">
        <div className="flex min-w-0 items-center gap-3">
          <img src="/sida-mark.svg" alt="SIDA" width={36} height={36} className="h-8 w-8 shrink-0" />
          <div className="min-w-0">
            <p className="truncate text-sm font-bold text-card-foreground sm:text-base">روشن تجارت کمپنی میں خوش آمدید</p> {/* i18n-allow: Urdu-only demo */}
            <p className="mt-0.5 text-[10px] text-muted-foreground sm:text-xs">آج کا مالیاتی خلاصہ</p> {/* i18n-allow: Urdu-only demo */}
          </div>
        </div>
        <span className="shrink-0 rounded-full border border-primary/25 bg-primary/10 px-2.5 py-1 text-[10px] font-semibold text-primary sm:text-xs">
          نمائشی ڈیٹا {/* i18n-allow: Urdu-only demo */}
        </span>
      </div>

      <div className="bg-muted/35 p-3 sm:p-5">
        <div className="grid gap-3 md:grid-cols-12 sm:gap-4">
          <section className="rounded-md border border-border bg-card p-4 md:col-span-7 sm:p-5" aria-labelledby="urdu-suppliers-title">
            <div className="mb-5 flex items-center justify-between gap-3">
              <div className="flex items-center gap-2">
                <span className="h-5 w-1 rounded-full bg-success" aria-hidden="true" />
                <h3 id="urdu-suppliers-title" className="text-sm font-bold text-card-foreground sm:text-base">سپلائرز اور واجبات</h3> {/* i18n-allow: Urdu-only demo */}
              </div>
              <span className="text-[10px] text-muted-foreground sm:text-xs">پچھلے 30 دن</span> {/* i18n-allow: Urdu-only demo */}
            </div>

            <div className="space-y-4">
              {suppliers.map((supplier) => (
                <div key={supplier.name}>
                  <div className="mb-1.5 flex items-center justify-between gap-3 text-[10px] sm:text-xs">
                    <span className="truncate font-medium text-card-foreground">{supplier.name}</span>
                    <span dir="ltr" className="shrink-0 font-bold tabular-nums text-card-foreground">SAR {supplier.amount}</span>
                  </div>
                  <div className="h-2 overflow-hidden rounded-full bg-muted">
                    <div className={`h-full rounded-full bg-success ${supplier.width}`} />
                  </div>
                </div>
              ))}
            </div>

            <div className="mt-5 flex items-end justify-between gap-3 border-t border-border pt-4">
              <span className="text-[10px] font-medium text-primary sm:text-xs">تمام کھاتے دیکھیں</span> {/* i18n-allow: Urdu-only demo */}
              <div className="text-left">
                <p className="text-[10px] text-muted-foreground sm:text-xs">کل واجب الادا</p> {/* i18n-allow: Urdu-only demo */}
                <p dir="ltr" className="mt-1 text-sm font-bold tabular-nums text-card-foreground sm:text-base">SAR 133,200.00</p>
              </div>
            </div>
          </section>

          <div className="grid grid-cols-2 gap-3 md:col-span-5 md:grid-cols-1">
            <div className="rounded-md border border-border bg-card p-3 sm:p-4">
              <div className="flex items-center gap-2 text-[10px] text-muted-foreground sm:text-xs">
                <WalletCards className="h-4 w-4 text-primary" aria-hidden="true" />
                <span>خالص کیش</span> {/* i18n-allow: Urdu-only demo */}
              </div>
              <p dir="ltr" className="mt-3 text-lg font-bold tabular-nums text-card-foreground sm:text-2xl">SAR 407,956.58</p>
            </div>

            <div className="rounded-md border border-border bg-card p-3 sm:p-4">
              <div className="flex items-center gap-2 text-[10px] text-muted-foreground sm:text-xs">
                <CheckCircle2 className="h-4 w-4 text-success" aria-hidden="true" />
                <span>خالص قابل وصول رقم</span> {/* i18n-allow: Urdu-only demo */}
              </div>
              <p dir="ltr" className="mt-3 text-lg font-bold tabular-nums text-card-foreground sm:text-2xl">SAR 91,692.00</p>
            </div>

            <div className="col-span-2 rounded-md border border-warning/45 bg-warning/10 p-3 md:col-span-1 sm:p-4">
              <div className="flex gap-3">
                <AlertTriangle className="mt-0.5 h-4 w-4 shrink-0 text-warning" aria-hidden="true" />
                <div>
                  <p className="text-xs font-bold text-card-foreground sm:text-sm">ڈرافٹ اندراجات: 1</p> {/* i18n-allow: Urdu-only demo */}
                  <p className="mt-1 text-[10px] leading-5 text-muted-foreground sm:text-xs">رپورٹس کی درستگی کے لیے ڈرافٹ اندراج کا جائزہ لیں۔</p> {/* i18n-allow: Urdu-only demo */}
                </div>
              </div>
            </div>
          </div>
        </div>

        <div className="mt-3 grid grid-cols-2 gap-3 sm:grid-cols-4">
          {[
            { icon: Banknote, label: "بینک بیلنس", value: "255,542.77" }, // i18n-allow: tri-locale data / Urdu-only demo
            { icon: WalletCards, label: "نقد رقم", value: "152,413.81" }, // i18n-allow: tri-locale data / Urdu-only demo
            { icon: CircleGauge, label: "مالیاتی ادوار", value: "1" }, // i18n-allow: tri-locale data / Urdu-only demo
            { icon: CheckCircle2, label: "ڈیٹا کی تکمیل", value: "96%" }, // i18n-allow: tri-locale data / Urdu-only demo
          ].map(({ icon: Icon, label, value }) => (
            <div key={label} className="rounded-md border border-border bg-card p-3">
              <div className="flex items-center gap-1.5 text-[9px] text-muted-foreground sm:text-[10px]">
                <Icon className="h-3.5 w-3.5 text-primary" aria-hidden="true" />
                <span>{label}</span>
              </div>
              <p dir="ltr" className="mt-2 text-xs font-bold tabular-nums text-card-foreground sm:text-sm">{value}</p>
            </div>
          ))}
        </div>
      </div>

      <div className="flex items-center justify-between gap-3 border-t border-border bg-card px-4 py-2 text-[9px] text-muted-foreground sm:px-6 sm:text-[10px]">
        <span>SIDA</span>
        <span>تمام نام اور اعداد فرضی ہیں</span> {/* i18n-allow: Urdu-only demo */}
      </div>
    </div>
  );
}